import { useCallback, useEffect, useState } from "react";

import { readImpersonation } from "./utils";
import type { ImpersonationState } from "./types";

export type UseImpersonationResult = {
  impersonation: ImpersonationState;
  impersonatedUserId: string | null;
  impersonatedMetadata: Record<string, unknown> | null;
  clearImpersonation: () => void;
};

// Owns the impersonation state: reads from localStorage on mount, logs a
// warning when active, and exposes a clear() helper that also reloads the
// page so consumers see the real session again.
export function useImpersonation(): UseImpersonationResult {
  const [impersonation, setImpersonation] = useState<ImpersonationState>({
    userId: null,
    metadata: null,
  });

  useEffect(() => {
    setImpersonation(readImpersonation());
  }, []);

  // Impersonation warnings removed for production

  const clearImpersonation = useCallback(() => {
    if (typeof window === "undefined") return;
    localStorage.removeItem("impersonate_user_id");
    localStorage.removeItem("impersonate_metadata");
    // Force re-render by refreshing the session
    window.location.reload();
  }, []);

  return {
    impersonation,
    impersonatedUserId: impersonation.userId,
    impersonatedMetadata: impersonation.metadata,
    clearImpersonation,
  };
}
